export const brandIcon =
  'https://upload.wikimedia.org/wikipedia/commons/1/14/US-NationalAgriculturalStatisticsService-Logo-Tagline.svg';

export const Brand_Logo = require(`./png/brand-logo-customer.png`);

export const SpecialMarkingIcons = {
  halal: require(`./png/halal.png`),
  'gluten free': require(`./png/gluten-free.png`),
  kosher: require(`./png/kosher.png`),
  vegetarian: require(`./png/vegetarian.png`),
  'non veg': require(`./png/mail.png`),
};

export const CreditCardIcons = {
  visa: require(`./png/visa-card.png`),
  mastercard: require(`./png/master-card.png`),
  'american express': require(`./png/american-express-card.png`),
  discover: require(`./png/discover-card.png`),
  'discover & diners club': require(`./png/discover-card.png`),
  'diners club': require(`./png/discover-card.png`),
  'fallback icon': require(`./png/fallback-creditcard.png`),
};

export const CustomerAccountIcons = {
  addresses: require(`./png/addresses-cust.png`),
  orders: require(`./png/orders-cust.png`),
  payments: require(`./png/payments-cust.png`),
  subscription: require(`./png/subscription-cust.png`),
};

export const PLATE_IMG = require(`./png/plate-mobile.png`);

export const EMAIL_SEND_PNG = require(`./png/mail.png`);
export const STORE_CLOSED_SHORT_TIME = require('./gif/closed.gif');
export const FIRE_COMPLEMENTARY = require('./gif/fire.gif');
export const COOKING_LOADER_CHECKOUT = require('./gif/cookingloader-checkout.gif');
export const STORE_NOT_FOUND_404 = require('./png/404-Panda-StoreNotFound.png');
export const PRODUCT_NOT_FOUND_404 = require('./png/404-Cat-ProductNotFound.png');
export const CUSTOMER_SUPPORT = require('./png/SupportContact.png');
export const UNDER_CONSTRUCTION = require('./png/UnderConstruction.png');
export const ABOUT_US_ONE = require('./png/AboutUs_1.png');
export const ABOUT_US_TWO = require('./png/AboutUs_2.png');

export const CONFIRM_PNG = require(`./png/mail.png`);
export const LOCATION_PNG = require(`./png/location-blue.png`);
export const THANK_YOU_PNG = require(`./png/Thankyou-career.png`);
export const CLOCK_PNG = require('./png/clock-blue.png');
export const GOOGLE_ICON = require('./png/google_on_white.png');
export const CELEBRITY_CHEF_PNG = require('./png/CelebrityChef-Icon.png');
export const HOME_TOPIC_ONE = require('./png/Topic-One.png');

export const TEST_FOOD_1_JPG = require('./png/TestFood1.jpeg');
export const TEST_FOOD_2_JPG = require('./png/TestFood2.jpeg');
export const TEST_FOOD_3_JPG = require('./png/TestFood3.jpeg');
export const CLOUD_TEST_1_JPG = require('./png/TestCloud1.jpeg');
export const CLOUD_TEST_2_JPG = require('./png/TestCloud2.jpeg');
export const CLOUD_TEST_3_JPG = require('./png/TestCloud3.jpeg');
export const CLOUD_TEST_4_JPG = require('./png/TestCloud4.jpeg');
export const CLOUD_TEST_5_JPG = require('./png/TestCloud5.jpeg');
export const CLOUD_TEST_6_JPG = require('./png/TestCloud6.jpeg');
export const CLOUD_TEST_7_JPG = require('./png/TestCloud7.jpeg');
export const CLOUD_TEST_8_JPG = require('./png/TestCloud8.jpeg');
export const CLOUD_TEST_9_JPG = require('./png/TestCloud9.png');
